export const insuranceAction = {
  setShowInsuranceModal: (state, action) => {
    state.showInsuranceModal = action.payload;
  },
  setIsProcessing: (state, action) => {
    state.isProcessing = action.payload;
  },
  setIsUpdateOperation: (state, action) => {
    state.isUpdateOperation = action.payload;
  },
  setSelectedInsurance: (state, action) => {
    state.selectedInsurance = action.payload;
  },
  setShowDeleteConfirmationModal: (state, action) => {
    state.showDeleteConfirmationModal = action.payload;
  },
};
